import { useState } from "react";
// @mui material components
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Icon from "@mui/material/Icon";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

export const DateRangePopup = ({ open, onClose, onConfirm }) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [allTime, setAllTime] = useState(false);

  const handleConfirm = () => {
      if (startDate > endDate ) {
        console.error("Invalid Dates !", { startDate, endDate });
        return;
      }
      onConfirm(startDate, endDate);
  };

  const handleCancel = () => {
    setStartDate(null);
    setEndDate(null);
    setAllTime(false);
    onClose();
  };

  const handleAllTimeChange = (event) => {
    const isChecked = event.target.checked;
    setAllTime(isChecked);
  };

  const isEndDateValid = !startDate || !endDate || new Date(endDate) >= new Date(startDate);
  const canConfirm = allTime || (startDate && endDate && isEndDateValid);

  return (
    <Dialog open={open} onClose={handleCancel} maxWidth="sm" fullWidth>
      <DialogTitle>
        <MDTypography variant="h6" fontWeight="medium">
          Select Date Range for Report
        </MDTypography>
      </DialogTitle>

      <DialogContent>
        <MDTypography variant="body2" color="text" mb={3}>
          Choose the start and end dates for your contract report.
        </MDTypography>

        <MDBox mb={2}>
          <FormControlLabel
            control={
              <Checkbox
                checked={allTime}
                onChange={handleAllTimeChange}
                color="primary"
              />
            }
            label="All Time (include all records regardless of date)"
          />
        </MDBox>

        <MDBox 
          display="flex" 
          flexDirection="column" 
          gap={3}
          sx={{ opacity: allTime ? 0.5 : 1, pointerEvents: allTime ? "none" : "auto" }}
        >
          <TextField
            label="Start Date"
            type="date"
            value={startDate || ""}
            onChange={(e) => setStartDate(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
            fullWidth
            disabled={allTime}
          />

          <TextField
            label="End Date"
            type="date"
            value={endDate || ""}
            onChange={(e) => setEndDate(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
            error={!isEndDateValid}
            helperText={!isEndDateValid ? "End date must be after start date" : ""}
            fullWidth
            disabled={allTime}
          />
        </MDBox>
      </DialogContent>

      <DialogActions>
        <MDButton variant="outlined" color="secondary" onClick={handleCancel}>
          Cancel
        </MDButton>
        <MDButton 
          variant="gradient" 
          color="info" 
          onClick={handleConfirm} 
          disabled={!canConfirm}
        >
          <Icon>save</Icon>&nbsp; Confirm
        </MDButton>
      </DialogActions>
    </Dialog>
  );
};

export default DateRangePopup;